// extracted by mini-css-extract-plugin
export var footer = "s_5";
export var footerContainer = "s_7";
export var logo = "s_6";